import $ from 'jquery';

class MaRSGlobalMenu {
  constructor() {
    //setTimeout(this.getMenu(), 750);
    this.resultsDiv = $("header").not(".page-header");
    this.showButton = $(".allServicesLevel__link");
    this.events();
    this.isSpinnerVisible = false;
  }

  events() {
    window.addEventListener("load", this.getMenu(this));
  }

  getMenu() {
    let marsSite = 'https://www.marsdd.com';
    this.resultsDiv.addClass('row');
    $.when($.getJSON(marsSite + '/wp-json/mars/v1/menu?name=main'),
      $.getJSON(marsSite + '/wp-json/mars/v1/menu?name=secondary'))
      .then((primary, secondary) => {
        this.resultsDiv.prepend(`
            <div class="mars-header globalNav row ${MaRS_PLUGIN.menu_pos ? 'globalNav__pos' : ''}">
            <div class="container mars-header__container site-global">
            
              <div class="mars-header__menuSearch" tabindex="0">
                <div class="mars-header__logo-text">
                  <a href="https://www.marsdd.com" target="_blank" class="mars-header__logo-link" title="MaRS Discovery District" aria-label="Go to MaRS Discovery District website" tabindex="0">
                    <svg xmlns="http://www.w3.org/2000/svg" width="85" height="26" viewBox="0 0 85 26" shape-rendering="crispEdges">
                      <g fill="#FFF" fill-rule="evenodd">
                        <path d="M16.994 24.68v-5.685c0-2.346.034-4.492.13-6.33-.68 1.767-1.86 4.527-2.645 6.229L11.473 25.5l-3.011-6.606a138.928 138.928 0 0 1-2.645-6.23c.1 1.84.128 3.985.128 6.331v5.685H0V.85h5.817l2.809 6.366c1.372 3.066 2.52 5.854 2.877 7.183.394-1.36 1.438-3.945 2.876-7.183L17.193.85h5.757v23.83h-5.956M35.244 16.958c-.653-.31-1.403-.515-2.512-.515-1.218 0-1.836.684-1.836 1.918 0 1.128.554 1.946 1.836 1.946.974 0 1.96-.406 2.512-.886v-2.463zm0 7.314v-1.198c-1.114.893-2.619 1.576-4.184 1.576-3.337 0-5.56-2.157-5.56-6.19 0-3.863 2.547-5.848 6.182-5.848 1.568 0 2.612.31 3.562.757v-.891c0-1.572-.816-2.116-2.42-2.116-1.764 0-3.104.338-4.777 1.292l-1.53-4.064c2.092-1.06 4.413-1.64 7.387-1.64 4.802 0 6.896 2.5 6.896 6.662v11.66h-5.556zM54.237 6.22h-3.808v5.207h3.715c2.047 0 2.864-.955 2.864-2.656 0-1.49-.781-2.55-2.771-2.55zm2.442 18.43l-3.712-8.02H50.43v8.02H44.2V.85h10.2c5.34 0 8.893 2.11 8.893 7.75 0 3.57-1.59 5.782-4.103 6.97l4.56 9.08h-7.07zM75.324 24.65c-3.783 0-7.428-1.263-9.874-2.904l3.144-5.188c1.71 1.195 4.688 2.393 6.865 2.393 2.31 0 3.046-.413 3.046-1.538 0-.89-.834-1.436-3.98-2.185-5.66-1.334-8.374-2.903-8.374-7.682C66.15 3.04 69.736 0 75.397 0c3.98 0 6.858.988 9.34 2.768l-3.153 5.19c-2.075-1.437-4.146-2.254-6.524-2.254-1.944 0-2.416.613-2.416 1.467 0 .89.84 1.302 3.853 2.013C82.39 10.62 85 12.458 85 16.934c0 5.465-4.046 7.716-9.676 7.716"/>
                      </g>
                    </svg>
                  </a>
                </div>
              
                <div class="mars-header__menu-trigger" aria-label="Open global menu" tabindex="0">
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
              </div>
    
              <div class="global-overlay-menu">
                <div class="global-overlay-menu__leftOrb" style="background: url('${MaRS_PLUGIN.image_url}/group-4@3x.png') no-repeat"></div>
                <div class="global-overlay-menu__topOrb" style="background: url('${MaRS_PLUGIN.image_url}/ma-rs-spheres-dimensional-rgb-pink-bottom@3x.png') no-repeat"></div>
                <div class="global-overlay-menu__bottomOrb" style="background: url('${MaRS_PLUGIN.image_url}/group-30.svg') no-repeat"></div>
                <div class="container">
                  <div class="row justify-content-md-center">
                    <div class="col col-12 col-md-2 col-lg-2"></div>
                    <div class="col col-12 mobileNav"></div>
                    <div class="col col-6 col-md-5 col-lg-4">
                      <nav>
                        <div class="menu-main-navigation-container">
                            ${primary[0].menu.length ? '<ul class="navigation__menu navigation__menu--overlay-left">' : '<p>Error from Global menu API.</p>'}
                            ${primary[0].menu.map(item => `
                              <li class="menu-item" role="menuitem">
                                <a class="" href="${item.url}" target="_blank">${item.title}</a>
                              </li>`
        ).join('')}
                          </ul>
                        </div>
                      </nav>
                    </div>
                    <div class="col col-6 col-md-3 col-lg-4">
                      <nav>
                         <div class="menu-secondary-menu-container">
                            ${secondary[0].menu.length ? '<ul id="secondary-menu" class="navigation__menu navigation__menu--overlay-right">' : '<p>Error from Global menu API.</p>'}
                            ${secondary[0].menu.map(item => `
                              <li class="menu-item" role="menuitem">
                                <a class="" href="${item.url}" target="_blank">${item.title}</a>
                              </li>`
        ).join('')}
                          </ul>
                        </div>
                      </nav>
                    </div>
                    <div class="col col-12 col-md-2 col-lg-2"></div>
                  </div>
                </div>
              </div>
            </div>  
          </div>
      `);
        this.isSpinnerVisible = false;
        $(".mobileNav").append($(".mars-header__menu").html());
        $("header").not(".page-header").append($(".site-menu-global").html());
        `${MaRS_PLUGIN.menu_pos ? $("body").addClass("mglobal") : ''}`;
        $("body").addClass("mars_universal")
      }).fail(function (jqXHR, textStatus, error) {
    });
  }
}

export default MaRSGlobalMenu;